import { PageContainer, ProTable } from "@ant-design/pro-components";
import { useCallback, useEffect, useState } from "react";
import { PAGINATION_INITIAL_VALUES } from "../../utils/constant";
import { useForm } from "antd/lib/form/Form";
import { useColumnsLeagueGames } from "../../components/Columns/leagueGames";
import { Button, Modal } from "antd";
import { ExclamationCircleFilled, PlusOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import { LeagueGamesAPI } from "../../api/leagueGames";
import { createQueryStringUrl } from "../../utils/createQueryStringUrl";

const LeagueGames = () => {
  const navigate = useNavigate();

  const { getLeagueGames, deleteLeagueGames } = LeagueGamesAPI;

  const [form] = useForm();

  const [pagination, setPagination] = useState(PAGINATION_INITIAL_VALUES);
  const [filterValues, setFilterValues] = useState({});
  const [leagueGames, setLeagueGames] = useState([]);
  const [selectedRecord, setSelectedRecord] = useState(null);

  const handleSubmitFilter = (params) => {
    const formValues = form.getFieldsValue();

    setFilterValues({
      ...filterValues,
      ...formValues,
    });

    setPagination((prevState) => ({
      ...prevState,
      currentPage: 1,
    }));
  };

  const handleResetFilter = () => {
    setFilterValues({});
    setPagination((prevState) => ({
      ...prevState,
      currentPage: 1,
    }));
  };

  const handleFetchLeagueGames = useCallback(async () => {
    try {
      createQueryStringUrl(filterValues);
      form.setFieldsValue(filterValues);

      const params = {
        ...filterValues,
        page: pagination.currentPage,
        limit: pagination.pageSize,
      };

      const { data } = await getLeagueGames(params);

      setLeagueGames(data.results);
      setPagination((prevState) => ({
        ...prevState,
        totalItems: data.total,
      }));
    } catch (error) {
      console.log("Error", error);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filterValues, form, pagination.currentPage, pagination.pageSize]);

  const showModal = (record) => {
    setSelectedRecord(record);
  };

  const handleSubmitModal = async () => {
    try {
      await deleteLeagueGames(selectedRecord?.id);

      await handleFetchLeagueGames();
    } catch (error) {
      console.log("Error", error);
    } finally {
      handleCancel();
    }
  };

  const handleCancel = () => setSelectedRecord(null);

  const columns = useColumnsLeagueGames(showModal);

  useEffect(() => {
    handleFetchLeagueGames();
  }, [handleFetchLeagueGames]);

  return (
    <PageContainer title="All League Games">
      <ProTable
        rowKey="id"
        request={({ pageSize }, filter) => {
          setPagination((prevState) => ({
            ...prevState,
            pageSize,
          }));
          return {
            filter,
          };
        }}
        onSubmit={(params) => handleSubmitFilter(params)}
        onReset={handleResetFilter}
        scroll={{ x: 800, y: 500 }}
        columns={columns}
        dataSource={leagueGames}
        pagination={{
          pageSize: pagination.pageSize,
          total: pagination.totalItems,
          onChange: (page) =>
            setPagination((prevState) => ({
              ...prevState,
              currentPage: page,
            })),
        }}
        toolBarRender={() => [
          <Button
            key="button"
            icon={<PlusOutlined />}
            onClick={() => {
              navigate("/league-game/new");
            }}
            type="primary"
          >
            New League Game
          </Button>,
        ]}
        search={{
          form: form,
          labelWidth: "auto",
        }}
      ></ProTable>

      {selectedRecord && (
        <Modal
          open={selectedRecord}
          onOk={() => handleSubmitModal()}
          onCancel={handleCancel}
          centered
        >
          <div className="delete-content">
            <ExclamationCircleFilled style={{ fontSize: "48px" }} />

            <p>Are you sure to delete this record?</p>
          </div>
        </Modal>
      )}
    </PageContainer>
  );
};

export default LeagueGames;
